import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { entWebsiteHowFragment } from 'bundles/ent-website/queries/EntWebsiteHow';
import { imageFragment } from 'bundles/ent-website/queries/common';

export const entWebsiteWhyFragment = contentfulGql`#graphql
  ${imageFragment}
  ${entWebsiteHowFragment}
  fragment EntWebsiteWhy on EntWebsiteWhy {
    slug
    headline
    description
    image {
      ...Image
    }
    howCollection(limit: 3) {
      items {
        __typename
        ...EntWebsiteHow
      }
    }
    ctaText
    ctaTarget

    # proofPoint
  }
`;

export const entWebsiteBlockWhyQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteWhyFragment}
  query entWebsiteBlockWhy($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteWhy
      }
    }
  }
`;
